// extracted by mini-css-extract-plugin
export default {"box":"Box_box__9szeO"};